'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotBarpolarIcon = function PlotBarpolarIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 1360 1360' }, props),
        _react2.default.createElement('path', { fill: 'currentColor', d: 'M436.395 296.519c-.035.024-132.838 63.18-168.071 176.888l113.017 77.533c27.173-50.264 66.14-95.117 116.285-129.927 3.922-2.722 7.916-5.272 11.899-7.825M907.083 618.819C954.8 702.082 943.541 805.4 882.72 876.277l248.645 147.556c34.558-50.135 71.658-119.84 87.054-203.214 32.22-174.515-44.787-317.497-44.787-317.497l.016-.008M833.271 726.291c0 67.024-54.335 121.356-121.359 121.356-67.021 0-121.353-54.332-121.353-121.356 0-67.021 54.331-121.353 121.353-121.353 67.024 0 121.359 54.332 121.359 121.353zM710.058 216.76a517.2 517.2 0 0 1 95.797 8.937l17.614-92.353c-122.54-22.829-251.963-8.079-369.683 47.472l36.725 85.027c66.594-31.461 141.009-49.083 219.547-49.083zM195.443 731.377c0-40.25 4.629-79.417 13.37-117.007l-88.215-20.637c-33.906 147.212-12.908 306.442 68.628 444.549l77.852-44.906c-45.492-76.747-71.635-166.313-71.635-261.999zM775.236 514.777c46.584 13.589 89.045 42.3 119.402 84.678l125.302-85.87c-10.704-14.181-81.113-103.261-186.458-139.721M751.772 509.24l28.458-149.199c-77.99-14.327-160.442-4.134-234.861 32.799l60.376 139.786c45.855-24.786 97.368-32.092 146.027-23.386zM520.673 847.101c-31.415-51.376-39.778-111.009-27.389-166.175L345.361 646.32c-20.933 91.694-7.544 190.861 43.773 276.665M669.68 950.522c-46.869-9.056-90.873-32.971-124.379-70.373l-95.508 109.614c47.968 83.938 189.86 109.751 189.945 109.767l29.942-149.008zM799.638 1236.97c86.811-12.874 206.11-90.075 259.565-127.28.373-.339 1.169-1.073 2.691-2.531L859.103 899.941a226.526 226.526 0 0 1-18.856 14.63c-34.726 24.105-73.889 37.037-113.209 39.593' })
    );
};

exports.default = PlotBarpolarIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotBarpolarIcon.js
// module id = 648
// module chunks = 0